import React from 'react';
import classNames from 'classnames';

import { PARTNER_LOGOS } from '../../constants';

import styles from './styles.module.css';

const LogoWall: React.FC = () => (
  <section className={styles.logoWall} aria-label="Brand partners">
    <div className={styles.shell}>
      <h2 className={styles.title}>
        Powering Resale for <em>Industry Leaders</em>
      </h2>
      <div className={styles.grid}>
        {PARTNER_LOGOS.map((logo) => (
          <div
            key={logo.alt}
            className={classNames(styles.logo, {
              [styles.small]: logo.small
            })}
          >
            <img
              src={logo.src}
              alt={logo.alt}
              width={logo.width}
              height={logo.height}
              decoding="async"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LogoWall;
